import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class NewCareLabelReferenceService extends BaseReferenceService {
  constructor() {
    super('NewCareLabelReference');
  }
}
